/**
 * Post-Round-96 Execution Loop — Preparing screen.
 *
 * Small, calm progress state shown by every asset-generating bot
 * page while `useAutoGenerate` invokes the generator. Replaces
 * the blank input form for the ~5–15 seconds it takes to prepare
 * the asset, so the customer never wonders "what do I do next?"
 *
 * Message copy follows the customer-oriented language principle:
 * describes what PayGBot is preparing, not what software is doing.
 */
import React from 'react';
import { Sparkle } from '@phosphor-icons/react';

const ASSET_LABELS = {
  email_sequence: 'today\u2019s email',
  offer: 'today\u2019s offer',
  sales_page: 'today\u2019s sales page',
  lead_magnet: 'today\u2019s lead magnet',
  generated_content: 'today\u2019s content',
  business_plan: 'today\u2019s next business step',
};

const PreparingScreen = ({ assetType, testId = 'preparing-screen' }) => {
  const what = ASSET_LABELS[assetType] || 'today\u2019s work';
  return (
    <div
      className="min-h-[280px] flex flex-col items-center justify-center text-center px-6 py-10"
      data-testid={testId}
    >
      <div className="mb-4 animate-pulse">
        <Sparkle weight="fill" className="w-10 h-10 text-amber-500" />
      </div>
      <h2
        className="text-2xl font-semibold text-slate-900 mb-2"
        data-testid={`${testId}-title`}
      >
        Preparing {what}&hellip;
      </h2>
      <p className="text-sm text-slate-600 max-w-md">
        PayGBot is putting together what you need using your business
        context. Give this a few seconds &mdash; it\u2019ll be ready
        for you to review, refine, and approve.
      </p>
    </div>
  );
};

export default PreparingScreen;
